/**
 * Возвращает массив ID всех вариантов ответа, которые уже были использованы.
 * @param {Object} answers - Текущий ответ (из useTaskHomeWork)
 * @returns {number[]} Массив ID использованных вариантов
 */
export const getUsedAnswerIds = ({answers}) => {
    const usedIds = [];
  
    if (answers && typeof answers === 'object') {
      Object.values(answers).forEach((basketAnswers) => {
        if (Array.isArray(basketAnswers)) {
          usedIds.push(...basketAnswers);
        }
      });
    }
  
    return usedIds;
  };